import React, { useEffect, useId, useRef, useState } from "react";
import "./index.less";
import { Button } from "antd";
import { Resource } from "@/types/resource";
import { throttle } from "lodash-es";

interface QuickStartProps {
  list: Resource.ResourceGuideType["content"];
  onClickCallBack?: (...arg: any) => void;
}
const prefix = "quick-start";
const QuickStart = (props: QuickStartProps) => {
  const { list, onClickCallBack } = props;
  const [showQuickStart, setShowQuickStart] = useState(true); // 控制是否显示快速开始
  const [loading, setLoading] = useState(false); // 控制是否显示加载中
  const contentId = useId();
  const [contentHeight, setContentHeight] = useState("1000px");
  const onDownloadHandle = () => {
    console.log("onDownloadHandle");
    setLoading(true);
    onClickCallBack &&
      onClickCallBack(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    const content = document.getElementById(contentId);
    let throttleResize:any= throttle(()=>{
      if (content) {
        console.log('set contentHeight')
        setContentHeight(getComputedStyle(content).height);
      }
    },300)
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // console.log("resizeObserver", entry.contentRect.height);
        throttleResize();
      }
    })
    if (content) {
      resizeObserver.observe(content);
    }
    return () => {
      resizeObserver.disconnect();
      throttleResize.cancel();
      throttleResize=null;
    }
  }, []);
  const height = showQuickStart ? contentHeight : "0px";
  console.log("QuickStart", contentHeight,height);
  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-wrap`}>
        <div className={`${prefix}-btn`} onClick={() => setShowQuickStart(true)}></div>
        <div 
        className="transition-box"
          style={{
            maxHeight: height,
          }}
        >
           <div
          className={`${prefix}-content`}
          id={contentId}
          
        >
          <div className={`${prefix}-content-close`} onClick={() => setShowQuickStart(false)}></div>

          <div className={`${prefix}-content-wrap`}>
            <div className={`${prefix}-content-wrap-box`}>
              <i className="guide-line"></i>
              <div className={`${prefix}-content-title`}>
                <svg viewBox="0 0 11 16">
                  <polygon points="0,0 11,0 11,11 5.5,16 0,11" fill="rgba(236, 164, 34, 1)" />
                </svg>
                <span>快速开始</span>
              </div>

              <div className={`${prefix}-content-step`}>
                {list.map((item, index) => {
                  return (
                    <div className={`${prefix}-content-step-item`} key={index}>
                      <div className={`${prefix}-content-step-item-title`}>
                        <span className="flex-center">{index + 1}</span>
                        {item.name}
                      </div>
                      {item.description && (
                        <div title={item.description} className={`${prefix}-content-step-item-desc `}>
                          {item.description}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex-center">
              <Button type="primary" loading={loading} size="large" className={`${prefix}-content-btn`} onClick={onDownloadHandle}>
                下载
              </Button>
            </div>
          </div>
        </div>
        </div>
       
      </div>
    </div>
  );
};

export default React.memo(QuickStart);
